/* global axios */
import { ref } from 'vue';

// Exclusão mútua de MÉTODO DE LIGAÇÃO por caixa (Wavoip / ByCall / API oficial:
// só um por caixa). Busca no backend quais estão ativos na caixa e ajuda a UI a
// desabilitar o toggle conflitante. A regra é garantida no backend
// (config/initializers/kanban_call_method_exclusion.rb); isto é só a camada de UX.
const LABELS = {
  wavoip: 'Wavoip',
  astracall: 'ByCall',
  official: 'API oficial',
};

export function useCallMethodExclusion() {
  const methods = ref({
    wavoip: false,
    astracall: false,
    official: false,
    is_official: false,
    is_hybrid: false,
  });
  const loaded = ref(false);

  const fetchMethods = async (accountId, inboxId) => {
    loaded.value = false;
    if (!accountId || !inboxId) {
      loaded.value = true;
      return;
    }
    try {
      const { data } = await axios.get(
        `/api/v1/accounts/${accountId}/kanban/connections/call_methods`,
        { params: { inbox_id: inboxId } }
      );
      methods.value = { ...methods.value, ...(data.data || {}) };
    } catch (e) {
      // fail-open: sem info, não bloqueia a UI (o backend ainda garante a regra)
    } finally {
      loaded.value = true;
    }
  };

  // Wavoip e API oficial CONVIVEM: em caixa Cloud/360 o Wavoip roda por cima do
  // número oficial, então depende da configuração oficial — é por ela que sai o
  // pedido de permissão de chamada da Meta, sem o qual a ligação não toca em
  // nenhum dos dois caminhos. Espelha PARES_COMPATIVEIS do backend.
  const COMPATIVEIS = [['official', 'wavoip']];
  const compativel = (a, b) =>
    COMPATIVEIS.some(par => par.includes(a) && par.includes(b));

  // Nomes (labels) dos OUTROS métodos já ativos que conflitam com `method`.
  const conflictLabelsFor = method =>
    ['wavoip', 'astracall', 'official']
      .filter(m => m !== method && methods.value[m] && !compativel(method, m))
      .map(m => LABELS[m]);

  return { methods, loaded, fetchMethods, conflictLabelsFor };
}
